import { useMemo } from 'react';
import { HStack } from '@cbhq/cds-web/layout';

import { AppSwitcher } from '../AppSwitcher';
import { IntlWrapper } from '../IntlWrapper';
import { ProfileMenu } from '../ProfileMenu';
import { useClientProps } from '../ProfileMenu/providers/ClientPropsProvider';
import { PACKAGE_VERSION_NAME } from '../version';

export function TopRightContent() {
  const {
    projectId,
    action,
    target,
    end: endAppendage,
    appSwitcherOptions,
    config,
    overrideLocale,
    showAppSwitcher = true,
  } = useClientProps();

  const configs = useMemo(() => {
    if (!appSwitcherOptions?.config && !config) return undefined;
    return { ...config, ...appSwitcherOptions?.config };
  }, [appSwitcherOptions?.config, config]);

  return (
    <HStack data-version={PACKAGE_VERSION_NAME} gap={1} alignItems="center" testID="TopRight">
      {endAppendage}
      <IntlWrapper overrideLocale={overrideLocale ?? config?.locale}>
        <HStack gap={1} alignItems="center">
          {showAppSwitcher && (
            <AppSwitcher
              {...appSwitcherOptions}
              projectId={projectId}
              action={action}
              target={target}
              config={configs}
              // Messages are fetched by identity-navigation
              skipFetchMessages
            />
          )}
          <ProfileMenu />
        </HStack>
      </IntlWrapper>
    </HStack>
  );
}
